<template>
  <div class="get-mq-game-container">
    <!-- 功能介绍区域 -->
    <div class="intro-section">
      <h1 class="title">魔趣游戏下载地址解析</h1>
      
      <!-- 真魔趣网站地址提示 -->
      <div class="official-site-notice">
        <div class="notice-header">
          <i class="el-icon-warning"></i>
          <span class="notice-title">⚠️ 重要提示</span>
        </div>
        <div class="notice-content">
          <p class="notice-text">请确保从<strong>真魔趣官网</strong>复制地址，避免使用假冒网站！</p>
          <div class="official-link">
            <span class="link-label">魔趣官网：</span>
            <a href="https://www.vrmoo.net" target="_blank" class="official-url">
              <i class="el-icon-link"></i>
              https://www.vrmoo.net
            </a>
            <el-button 
              type="text" 
              size="mini" 
              class="copy-btn"
              @click="copyOfficialUrl"
            >
              <i class="el-icon-copy-document"></i>
              复制
            </el-button>
          </div>
        </div>
      </div>
      
      <div class="intro-content">
        <p><strong>本站作者:</strong> tnsheng1234</p>
        <p><strong>本页面功能：</strong>解析目标页面地址的下载地址，提供真实下载地址。</p>
        <p>
          <strong>使用教程：</strong
          >把魔趣地址的URL粘贴到输入框中，点击按钮解析。大概30秒钟之内，即可获取到最新的魔趣下载地址。本功能只支持网盘解析，不支持直连下载。
        </p>
      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-box">
        <el-input
          v-model="url"
          placeholder="请输入魔趣网址 (例如: https://www.vrmoo.net/43932.html)"
          :clearable="true"
          @keyup.enter="handleParse"
        >
        </el-input>
        <el-button type="primary" :loading="loading" @click="handleParse"
          >解析下载地址</el-button
        >
      </div>
    </div>

    <!-- 结果展示区域 -->
    <div v-if="downloadUrl" class="result-section">
      <el-alert title="解析成功" type="success" :closable="false" show-icon>
        <template #default>
          <p class="download-link">
            下载地址：<a :href="downloadUrl" target="_blank">{{ downloadUrl }}</a>
          </p>
        </template>
      </el-alert>
    </div>

    <!-- 错误提示 -->
    <el-dialog
      :visible.sync="errorVisible"
      title="错误提示"
      width="50%"
      :close-on-click-modal="false"
    >
      <span>{{ errorMessage }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="errorVisible = false">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getSingleGame } from "../api/index";

export default {
  name: "GetMqGame",
  data() {
    return {
      url: "",
      loading: false,
      downloadUrl: "",
      errorVisible: false,
      errorMessage: "",
    };
  },
  methods: {
    // 验证URL格式
    validateUrl(url) {
      const pattern = /^https:\/\/www\.vrmoo\.net\/\d+\.html$/;
      console.log(pattern.test(url))
      return pattern.test(url);
      
    },
    // 解析URL获取ID
    getGameId(url) {
      const matches = url.match(/\/(\d+)\.html$/);
      return matches ? matches[1] : null;
    },
    // 处理解析请求
    async handleParse() {
      if (!this.url) {
        this.showError("请输入魔趣网址");
        return;
      }

      if (!this.validateUrl(this.url)) {
        this.showError(
          "请输入正确的魔趣网址格式，例如：https://www.vrmoo.net/43932.html"
        );
        return;
      }

      const gameId = this.getGameId(this.url);
      if (!gameId) {
        this.showError("无法从URL中提取游戏ID");
        return;
      }
      this.downloadUrl = "";
      this.loading = true;
      try {
        // TODO: 替换为实际的API调用
        const response = await getSingleGame(gameId)
         this.downloadUrl = `${location.origin}/gameMqDetail/${response.data.id}`
      } catch (error) {
        this.showError("获取下载地址失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    // 显示错误信息
    showError(message) {
      this.errorMessage = message;
      this.errorVisible = true;
    },
    
    // 复制官网地址
    copyOfficialUrl() {
      const officialUrl = 'https://www.vrmoo.net';
      
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(officialUrl).then(() => {
          this.$message.success('官网地址已复制到剪贴板');
        }).catch(() => {
          this.fallbackCopyText(officialUrl);
        });
      } else {
        this.fallbackCopyText(officialUrl);
      }
    },
    
    // 兼容性复制方法
    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.$message.success('官网地址已复制到剪贴板');
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
      }
      
      document.body.removeChild(textArea);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/dark-theme.scss";

.get-mq-game-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 100vh;
  background: $dark;
}

.intro-section {
  width: 100%;
  margin-bottom: 40px;
  text-align: center;
}

.title {
  font-size: 32px;
  color: white;
  margin-bottom: 20px;
  font-weight: 700;
  @include gradient-text;
}

.intro-content {
  text-align: left;
  background: $card;
  padding: 24px;
  border-radius: $radius-xl;
  margin: 0 auto;
  border: $border-lighter;
  box-shadow: $shadow-sm;
}

.intro-content p {
  margin: 12px 0;
  line-height: 1.8;
  color: $slate-300;
}

.search-section {
  width: 100%;
  margin-bottom: 30px;
}

.search-box {
  display: flex;
  gap: 12px;
  margin: 0 auto;

  :deep(.el-input__inner) {
    background: $card;
    border-color: rgba(255, 255, 255, 0.1);
    color: white;
    border-radius: $radius-xl;
    height: 48px;
    font-size: 15px;

    &::placeholder {
      color: $slate-400;
    }

    &:focus {
      border-color: $primary;
      box-shadow: 0 0 0 3px rgba($primary, 0.1);
    }
  }

  :deep(.el-button--primary) {
    background: $gradient-primary;
    border: none;
    border-radius: $radius-xl;
    height: 48px;
    padding: 0 32px;
    font-weight: 600;
    transition: $transition-normal;

    &:hover {
      opacity: 0.9;
      transform: translateY(-2px);
      box-shadow: $shadow-primary;
    }
  }
}

.result-section {
  width: 100%;
  margin-top: 20px;

  :deep(.el-alert) {
    background: rgba(103, 194, 58, 0.1);
    border: 1px solid rgba(103, 194, 58, 0.3);
    border-radius: $radius-md;

    .el-alert__title {
      color: #67c23a;
    }
  }
}

.download-link {
  margin-top: 10px;
  word-break: break-all;
  color: $slate-300;
}

.download-link a {
  color: $primary;
  text-decoration: none;
  font-weight: 500;
  transition: $transition-fast;

  &:hover {
    color: $secondary;
    text-decoration: underline;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .get-mq-game-container {
    padding: 15px;
  }

  .title {
    font-size: 20px;
  }

  .search-box {
    flex-direction: column;
  }

  .el-button {
    width: 100%;
  }
}


/* 真魔趣网站提示样式 */
.official-site-notice {
  background: linear-gradient(135deg, rgba(251, 191, 36, 0.15) 0%, rgba(245, 158, 11, 0.15) 100%);
  border: 2px solid rgba(251, 191, 36, 0.5);
  border-radius: $radius-xl;
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: 0 4px 20px rgba(251, 191, 36, 0.2);
  animation: gentle-pulse 3s infinite;
  backdrop-filter: blur(8px);
}

.notice-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.notice-header i {
  font-size: 22px;
  color: #fbbf24;
  margin-right: 10px;
  animation: warning-blink 2s infinite;
}

.notice-title {
  font-size: 18px;
  font-weight: 700;
  color: #fbbf24;
}

.notice-content {
  text-align: left;
}

.notice-text {
  margin: 0 0 16px 0;
  color: $slate-200;
  font-size: 15px;
  line-height: 1.6;
}

.official-link {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: $radius-md;
  border: 1px solid rgba(251, 191, 36, 0.3);
}

.link-label {
  font-weight: 600;
  color: #fbbf24;
  font-size: 14px;
}

.official-url {
  display: flex;
  align-items: center;
  color: $primary;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  transition: $transition-normal;
  padding: 6px 12px;
  border-radius: $radius-sm;
  background: rgba($primary, 0.1);
}

.official-url:hover {
  color: $secondary;
  background: rgba($secondary, 0.1);
  transform: translateY(-1px);
}

.official-url i {
  margin-right: 6px;
  font-size: 14px;
}

.copy-btn {
  color: #67c23a !important;
  font-size: 13px;
  padding: 6px 12px !important;
  border: 1px solid rgba(103, 194, 58, 0.5);
  border-radius: $radius-sm;
  transition: $transition-normal;
  background: rgba(103, 194, 58, 0.1);
}

.copy-btn:hover {
  background: #67c23a !important;
  color: white !important;
  transform: translateY(-1px);
}

@keyframes gentle-pulse {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(243, 156, 18, 0.2);
  }
  50% {
    box-shadow: 0 6px 20px rgba(243, 156, 18, 0.3);
  }
}

@keyframes warning-blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .official-site-notice {
    padding: 15px;
  }
  
  .official-link {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .link-label {
    margin-bottom: 5px;
  }
  
  .official-url {
    word-break: break-all;
    width: 100%;
  }
  
  .copy-btn {
    align-self: flex-end;
    margin-top: 8px;
  }
}

</style>

